import {Component, ViewChild} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {ToastrService} from 'ngx-toastr';
import {NgSelectModule} from "@ng-select/ng-select";
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {ApiService} from "@ctms/api.service";
import {SpinnerComponent} from "@shared/components/spinner/spinner.component";
import {Page} from "@ctms/api/api.interfaces";
import {RouterLink} from "@angular/router";
import {BreadcrumbService} from "@cdss/services/breadcrumb.service";

@Component({
    selector: 'demo-patient-list',
    imports: [CommonModule, ReactiveFormsModule, SpinnerComponent, NgSelectModule, NgxDatatableModule, RouterLink],
    providers: [ApiService],
    templateUrl: './patient-list.component.html'
})
export class DemoPatientListComponent {
    errorMessage!: string;
    loading = false;

    @ViewChild("table") table: any;

    page: Page = {
        size: 10,
        start: 0,
        totalCount: 10
    };
    offset: number = 0
    rows: any[
    ] = [
        {
            id: 1,
            name: "Jane Smith",
            code: "0129039302",
            weight: 32.8,
            bmi: 11.3,
            plan: "Comfort"
        },
        {
            id: 2,
            name: "Sophie Richardson",
            code: "0129039303",
            weight: 33.8,
            bmi: 11.7,
            plan: "Comfort"
        },
        {
            id: 3,
            name: "Harriet Lawson",
            code: "0129039302",
            weight: 33.2,
            bmi: 11.6,
            plan: "Comfort"
        },
        {
            id: 1,
            name: "Jane Smith",
            code: "0129039302",
            weight: 32.8,
            bmi: 11.3,
            plan: "Comfort"
        },
        {
            id: 1,
            name: "Jane Smith",
            code: "0129039302",
            weight: 32.8,
            bmi: 11.3,
            plan: "Comfort"
        },
        {
            id: 1,
            name: "Jane Smith",
            code: "0129039302",
            weight: 32.8,
            bmi: 11.3,
            plan: "Comfort"
        },
        {
            id: 1,
            name: "Jane Smith",
            code: "0129039302",
            weight: 32.8,
            bmi: 11.3,
            plan: "Comfort"
        },
        {
            id: 1,
            name: "Jane Smith",
            code: "0129039302",
            weight: 32.8,
            bmi: 11.3,
            plan: "Comfort"
        },
        {
            id: 1,
            name: "Jane Smith",
            code: "0129039302",
            weight: 32.8,
            bmi: 11.3,
            plan: "Comfort"
        },
        {
            id: 1,
            name: "Jane Smith",
            code: "0129039302",
            weight: 32.8,
            bmi: 11.3,
            plan: "Comfort"
        },
    ]
    sortField: string = 'participantCode'
    order: string = 'asc'

    filterForm: FormGroup

    constructor(
        public toastr: ToastrService,
        private breadcrumbService: BreadcrumbService,
    ) {
    }

    ngOnInit(): void {
        this.breadcrumbService.set([
            {title: "Patients", url: null},
        ])

        this.filterForm = new FormGroup({
            study: new FormControl(),
            site: new FormControl(),
            status: new FormControl(),
            lastName: new FormControl(),
            participantCode: new FormControl(),
            includesDemo: new FormControl(),
        });
    }

    reset(): void {

    }

    filter(): void {

    }

    setPage(pageInfo) {
        this.loading = true
        this.page.start = pageInfo.offset * this.page.size
        this.refreshRows()
    }

    sort(pageInfo) {
        this.loading = true
        this.sortField = pageInfo.sorts[0].prop
        this.order = pageInfo.sorts[0].dir
        this.table.offset = this.page.start
        this.refreshRows()
    }

    refreshRows() {

    }
}
